"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applicationClick = void 0;
var analytics_layer_1 = require("@pmi/analytics-layer");
var consts_1 = require("../consts");
var applicationClick = function (event) {
    var eventData = {
        action: event.eventData.action || consts_1.NOT_AVAILABLE,
        event: analytics_layer_1.LinkInteractionEventNames.ApplicationClick,
        eventInfo: analytics_layer_1.LinkInteractionEventNames.ApplicationClick,
        certification: {
            applicationID: event.eventData.certification.applicationID || consts_1.NOT_AVAILABLE,
            certName: event.eventData.certification.certName || consts_1.NOT_AVAILABLE,
            status: event.eventData.certification.status || consts_1.NOT_AVAILABLE,
            step: event.eventData.certification.step || consts_1.NOT_AVAILABLE,
            certLanguage: event.eventData.certification.certLanguage || consts_1.NOT_AVAILABLE,
        },
    };
    return eventData;
};
exports.applicationClick = applicationClick;
